export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const GET_USER = "GET_USER";

//roles
export const GET_ROLES = "GET_ROLES";
export const ADD_ROLES = "ADD_ROLES";
export const SHOW_ROLES = "SHOW_ROLES";
export const EDIT_ROLES = "EDIT_ROLES";

//Usuarios
export const GET_USUARIOS = "GET_USUARIOS";
export const ADD_USUARIOS = "ADD_USUARIOS";
export const SHOW_USUARIOS = "SHOW_USUARIOS";
export const EDIT_USUARIOS = "EDIT_USUARIOS";

//Modulos
export const GET_MODULOS = "GET_MODULOS";
export const ADD_MODULOS = "ADD_MODULOS";
export const SHOW_MODULOS = "SHOW_MODULOS";
export const EDIT_MODULOS = "EDIT_MODULOS";

//Visitas
export const GET_VISITAS = "GET_VISITAS";
export const ADD_VISITAS = "ADD_VISITAS";
export const SHOW_VISITAS = "SHOW_VISITAS";
export const EDIT_VISITAS = "EDIT_VISITAS";
